import React from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectApi from '../../common/SelectApi';
import { WidgetDestPointNetoProps } from '../Dashboard.types';

interface DestPointNetoFiltersProps {
 control: Control<WidgetDestPointNetoProps>;
 setValue: UseFormSetValue<WidgetDestPointNetoProps>;
 errors: FieldErrors<WidgetDestPointNetoProps>;
}

const DestPointNetoFilters: React.FC<DestPointNetoFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const { t } = useTranslation();
 const productFilter = JSON.stringify({ fields: 'Id,Name' });

 const destPointFilter = JSON.stringify({ fields: 'Id,Name' });
 return (
  <>
   <SelectApi<WidgetDestPointNetoProps>
    name="toDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label={t('dashboard.filters.toDestPointLabel')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
    multiple
   />
   <SelectApi<WidgetDestPointNetoProps>
    name="products"
    url="/api/Products/v2/"
    filter={productFilter}
    label={t('dashboard.filters.products')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
  </>
 );
};

export default DestPointNetoFilters;
